import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface Toast {
  id: number;
  type: ToastType;
  header?: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _toasts: Toast[] = [];
  private _subject = new BehaviorSubject<Toast[]>([]);
  private _nextId = 1;

  public get toasts$(): Observable<Toast[]> {
    return this._subject.asObservable();
  }

  public show(type: ToastType, header: string | undefined, message: string, duration = 3000): number {
    const id = this._nextId++;
    const t: Toast = { id, type, header, message };
    this._toasts = [...this._toasts, t];
    this._subject.next(this._toasts);
    if (duration && duration > 0) {
      setTimeout(() => this.dismiss(id), duration);
    }
    return id;
  }

  public dismiss(id: number): void {
    this._toasts = this._toasts.filter(t => t.id !== id);
    this._subject.next(this._toasts);
  }

  public clear(): void {
    this._toasts = [];
    this._subject.next(this._toasts);
  }
}
